<template>
  <v-select
    v-if="tagsOptions"
    ref="tagsSelector"
    v-model="tagsFilter"
    :options="tagsOptions"
    class="w-100"
    multiple
    :disabled="disabled"
    :taggable="taggable"
    :push-tags="taggable"
    :placeholder="$t('contributors.filter-tags')"
    :reduce="val => val.label"
  >
    <template
      slot="selected-option"
      slot-scope="option"
    >
      <b-badge
        class="mr-25"
        :style="{ 'background-color': tagsColors ? resolveTagBackground(option.label, tagsColors) : 'lightgray' }"
        pill
        :href="(invertable ? '#' : null)"
        @click="invert(option.label)"
      >&nbsp;<feather-icon
        v-if="resolveTagIcon(option.label) !== null"
        :icon="resolveTagIcon(option.label)"
      />&nbsp;
      </b-badge>
      <span :class="inverted.includes(option.label) ? 'text-decoration-line-through' : null"> {{ option.label }}</span>
    </template>
    <template #option="{ label }">
      <b-badge
        v-if="tagsColors"
        class="mr-25"
        :style="{ 'background-color': resolveTagBackground(label, tagsColors) }"
        pill
      >&nbsp;<feather-icon
        v-if="resolveTagIcon(label) !== null"
        :icon="resolveTagIcon(label)"
      />&nbsp;
      </b-badge>
      <span> {{ label }}</span>
    </template>
  </v-select>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  resolveTagBackground, resolveTagIcon,
} from '@/views/layouts/layouts.utils'

export default {
  components: {
    BBadge, vSelect,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    tagsOptions: {
      type: Array,
      default: null,
    },
    tagsColors: {
      type: Array,
      default: null,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invertable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inverted: [],
    }
  },
  computed: {
    tagsFilter: {
      get() {
        if (!this.value) return this.value
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.inverted = this.value.filter(o => o.startsWith('!!')).map(o => o.substring(2))
        return this.value.map(o => (o.startsWith('!!') ? o.substring(2) : o))
      },
      set(value) { this.$emit('input', value.map(o => `${(this.inverted.includes(o) ? '!!' : '')}${o}`)) },
    },
  },
  methods: {
    invert(label) {
      if (!this.invertable) return
      const { searchEl } = this.$refs.tagsSelector
      if (searchEl) {
        searchEl.blur()
      }
      if (this.inverted.includes(label)) this.inverted = this.inverted.filter(o => o !== label)
      else this.inverted.push(label)
      // eslint-disable-next-line no-self-assign
      this.tagsFilter = this.tagsFilter
    },
  },
  setup() {
    return {
      resolveTagBackground, resolveTagIcon,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.text-decoration-line-through {
  text-decoration: line-through;
}
</style>
